import React from 'react';
import AppBaseComponent from '../../../../components/AppBaseComponent';
import {connect} from "react-redux";
import tapIcon from "../../../../services/TapIcon";
import Ax from '../../../../components/hoc/Ax';
import HttpAPICall from '../../../../services/HttpAPICall';
import { ISC_SALES_ORDER_URL } from '../../../../services/TapApiUrls';
import Loader from '../../../../components/ui/Loader/Loader';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import TapSelect from '../../../../components/ui/TapSelect';
import { Link } from 'react-router-dom';

class Workflow extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.initAddStatusForm = {
            name: '',
            role_ids: [],
            notes: ''
        }

        this.state = {
            statusList: [],
            listing_loading: false,
            addStatusForm: {...this.initAddStatusForm},
            allRoleList: [], // This will store all roles for mapping
            roleMap: {}, // This will store id -> role name mapping for quick lookup
            addFormDataLoaded: false,
            addStatusFormSubmitting: false,
            can_Edit: true,
            edit: false,
            form_loaded: false,
            isLoaded: false,
            modalInitialized: false
        }

        this.salesOrderStatusFormDataUrl = ISC_SALES_ORDER_URL + "/config/status_form_data";
        this.salesOrderStatusListUrl = ISC_SALES_ORDER_URL + "/config/status_list";
        this.salesOrderStatusEditUrl = ISC_SALES_ORDER_URL + "/config/status_edit";
        this.salesOrderStatusAddUrl = ISC_SALES_ORDER_URL + "/config/status_add";
        this.salesOrderStatusDeleteUrl = ISC_SALES_ORDER_URL + "/config/status_delete";
        this.addStatusModal = null;
    }

    componentDidMount() {
        if (this.props.loaded === undefined || this.props.loaded === true) {
            this.getStatusListing();
            this.initModal();
            this.loadRoles(); // Load roles immediately
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.loaded !== undefined) {
            if (this.props.loaded && !prevProps.loaded && !this.state.isLoaded) {
                this.getStatusListing();
                this.initModal();
                this.loadRoles(); // Load roles when tab becomes active
            }
        }
    }

    initModal = () => {
        if (!this.state.modalInitialized) {
            const modalElement = document.getElementById('addStatusModal');
            if (modalElement) {
                this.addStatusModal = new Modal(modalElement, { 
                    keyboard: false, 
                    backdrop: false 
                });
                this.setState({ modalInitialized: true });
            }
        }
    }

    // Load roles and create a mapping for quick lookup
    loadRoles = () => {
        if (!this.state.addFormDataLoaded) {
            HttpAPICall.withAthorization('GET', this.salesOrderStatusFormDataUrl, this.props.access_token, null, null, (response) => {
                const roleList = response.data.data.roles.map((role) => { 
                    return { 
                        value: role.id, 
                        label: role.role 
                    };
                });
                
                // Create a map for quick role name lookup
                const roleMap = {};
                response.data.data.roles.forEach(role => {
                    roleMap[role.id] = role.role;
                });
                
                this.setState({
                    addFormDataLoaded: true,
                    allRoleList: roleList,
                    roleMap: roleMap
                });
            });
        }
    }

    getStatusListing = () => {
        this.setState({ listing_loading: true });
        HttpAPICall.withAthorization('GET', this.salesOrderStatusListUrl, this.props.access_token, {}, {}, (response) => {
            this.setState({ 
                statusList: response.data.data,
                isLoaded: true 
            });
        }).then(() => this.setState({ listing_loading: false }));
    }

    refreshData = () => {
        this.getStatusListing();
    }

    addFormDataInit = () => {
        this.loadRoles(); // Use the same method
    }

    addStatusModalInit = () => {
        this.initModal();
        if (this.addStatusModal) {
            this.addStatusModal.show();
            this.addFormDataInit();
            this.setState({ 
                can_Edit: true, 
                edit: false,
                addStatusForm: { ...this.initAddStatusForm }
            });
        }
    }

    openEditStatus = (id) => {
        this.initModal();
        if (this.addStatusModal) {
            this.addStatusModal.show();
            this.setState({ form_loaded: true });
            
            // Ensure roles are loaded
            this.loadRoles();
            
            // Find the status to edit
            let statusList = this.state.statusList.find(function (transaction) {
                return transaction.id == id;
            });

            if (statusList) {
                // Extract role IDs - roles is already an array of IDs
                const roleIds = statusList.roles || [];
                
                this.setState({
                    addStatusForm: {
                        name: statusList.name || '',
                        notes: statusList.notes === null ? "" : statusList.notes || '',
                        id: statusList.id,
                        role_ids: roleIds // Array of role IDs
                    },
                    can_Edit: statusList.can_edit !== undefined ? statusList.can_edit : true,
                    edit: true,
                    form_loaded: false
                });
            } else {
                this.setState({ form_loaded: false });
                toast.error('Status not found', { position: toast.POSITION.TOP_RIGHT });
            }
        }
    }

    submitAddStatusForm = (e) => {
        e.preventDefault();
        let frmData = { ...this.state.addStatusForm };

        this.setState({ addStatusFormSubmitting: true });

        if (this.state.edit) {
            HttpAPICall.withAthorization('PUT', this.salesOrderStatusEditUrl, this.props.access_token, {}, { ...frmData }, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                if (this.addStatusModal) {
                    this.addStatusModal.hide();
                }
                this.refreshData();
                this.setState({ 
                    addStatusForm: { ...this.initAddStatusForm }, 
                    can_Edit: true,
                    edit: false
                });
            }).then(() => this.setState({ addStatusFormSubmitting: false }));
        } else {
            HttpAPICall.withAthorization('POST', this.salesOrderStatusAddUrl, this.props.access_token, {}, { ...frmData }, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                if (this.addStatusModal) {
                    this.addStatusModal.hide();
                }
                this.refreshData();
                this.setState({ 
                    addStatusForm: { ...this.initAddStatusForm }, 
                    can_Edit: true,
                    edit: false
                });
            }).then(() => this.setState({ addStatusFormSubmitting: false }));
        }
    }

    deleteStatus = (id) => {
        swal({
            title: "DELETE",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            buttons: ["No", "Yes"],
        })
            .then(willDelete => {
                if (willDelete) {
                    let statusList = this.state.statusList.find(function (group) {
                        return group.id == id;
                    });
                    HttpAPICall.withAthorization('DELETE', this.salesOrderStatusDeleteUrl + '/' + id, this.props.access_token, {}, { statusList }, (response) => {
                        toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                        this.refreshData();
                    }).then(() => {});
                }
            });
    }

    // Helper method to get role names from role IDs using the roleMap
    getRoleNamesForDisplay = (roleIds) => {
        if (!roleIds || roleIds.length === 0) {
            return '';
        }
        
        // Use the roleMap for quick lookup
        return roleIds
            .map(id => this.state.roleMap[id] || '')
            .filter(name => name !== '')
            .join(', ');
    }

    addStatusModalJsx = () => {
        return (
            <div className="modal fade" id="addStatusModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addStatusModalLabel">{this.state.edit ? "Edit" : "Add"} Status</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.submitAddStatusForm} id="addStatusForm" method="post" encType="multipart/form-data">
                            <div className="modal-body">
                                {this.state.form_loaded ? <Loader />
                                    : <Ax>
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-3">
                                                <label htmlFor="statusName" className="form-label require">Status Name</label>
                                            </div>
                                            <div className="col-sm-9">
                                                <input
                                                    name="name"
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    disabled={this.state.can_Edit == false}
                                                    onChange={(e) => { this.formInputHandler(e, 'addStatusForm') }}
                                                    value={this.state.addStatusForm.name}
                                                    placeholder="Please Enter Status Name"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-3">
                                                <label htmlFor="notes" className="form-label">Notes</label>
                                            </div>
                                            <div className="col-sm-9">
                                                <input
                                                    name="notes"
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    disabled={this.state.can_Edit == false}
                                                    onChange={(e) => { this.formInputHandler(e, 'addStatusForm') }}
                                                    value={this.state.addStatusForm.notes}
                                                    placeholder="Please Enter Notes"
                                                />
                                            </div>
                                        </div>
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-3">
                                                <label htmlFor="roles" className="form-label require">Role</label>
                                            </div>
                                            <div className="col-sm-9">
                                                <TapSelect
                                                    options={this.state.allRoleList}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'addStatusForm', 'role_ids')}
                                                    value={this.state.allRoleList.filter(u => this.state.addStatusForm?.role_ids?.includes(u.value))}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    isClearable={true}
                                                    placeholder="Select Roles"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    isDisabled={this.state.can_Edit == false}
                                                />
                                            </div>
                                        </div>
                                    </Ax>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" disabled={this.state.addStatusFormSubmitting} className="btn btn-secondary mx-2" data-bs-dismiss="modal" onClick={() => { this.setState({ addStatusForm: { ...this.initAddStatusForm } }) }}>Close</button>
                                <button type="submit" disabled={this.state.addStatusFormSubmitting || this.state.can_Edit == false} className="btn btn-primary">
                                    Submit {this.state.addStatusFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.loaded !== undefined && !this.props.loaded) {
            return null;
        }

        return (
            <Ax>
                <div className="tab_content_wrapper">
                    <span className="content_heading">Status for Sales Order <tapIcon.FontAwesomeIcon icon={tapIcon.faInfoCircle} /></span>
                    <div className="float-end">
                        <button 
                            className="btn btn-primary" 
                            disabled={!this.props.permissions?.includes('isc-po-status-manage')} 
                            onClick={this.addStatusModalInit}
                        >
                            Add Status
                        </button>
                    </div>
                </div>
                <table className="table table-hover table-bordered my-3 ">
                    <thead>
                        <tr className='table-secondary'>
                            <th scope="col" style={{ width: "20%" }}>Status</th>
                            <th scope="col" style={{ width: "40%" }}>Roles</th>
                            <th scope="col" style={{ width: "40%" }}>Notes</th>
                        </tr>
                    </thead>
                    <tbody className="table-body">
                        {this.state.listing_loading
                            ? <tr>
                                <td className="text-center" colSpan="3"><Loader /></td>
                            </tr>
                            : this.state.statusList && this.state.statusList.length > 0 ? (
                                this.state.statusList.map((item, index) => {
                                    // Get role names for display using the roleMap
                                    const roleNames = item.system_generated === "Y" 
                                        ? '' 
                                        : this.getRoleNamesForDisplay(item.roles);
                                    
                                    return <tr key={item.id}>
                                        <td scope="row">{item.name}</td>
                                        <td scope="row">{roleNames}</td>
                                        <td scope="row">
                                            <div className="row">
                                                <div className="col-10">
                                                    {item.notes === null || item.notes === '' ? "-" : item.notes}
                                                </div>
                                                {item.system_generated === "Y" ? null :
                                                    <div className="col-2 text-center">
                                                        <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid pr10 pl10"
                                                            data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false"
                                                        />
                                                        <ul className="dropdown-menu">
                                                            <li>
                                                                <Link role="button"
                                                                    onClick={() => {
                                                                        if (this.props?.permissions?.includes('isc-configuration-edit')) {
                                                                            return this.openEditStatus(item.id)
                                                                        }
                                                                    }}
                                                                    className={['dropdown-item cursor_pointer', this.props?.permissions?.includes('isc-configuration-edit') ? '' : 'disabled'].join(' ')}
                                                                    title={!this.props?.permissions?.includes('isc-configuration-edit') ? 'You do not have permission to perform this action' : ''}
                                                                    style={{ "pointerEvents": "all" }}
                                                                >Edit</Link>
                                                            </li>
                                                            {item.can_delete !== false && (
                                                                <li>
                                                                    <Link role="button"
                                                                        onClick={() => {
                                                                            if (this.props?.permissions?.includes('isc-configuration-edit')) {
                                                                                return this.deleteStatus(item.id)
                                                                            }
                                                                        }}
                                                                        className={['dropdown-item cursor_pointer', this.props?.permissions?.includes('isc-configuration-edit') ? '' : 'disabled'].join(' ')}
                                                                        title={!this.props?.permissions?.includes('isc-configuration-edit') ? 'You do not have permission to perform this action' : ''}
                                                                        style={{ "pointerEvents": "all" }}
                                                                    >Delete</Link>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                })
                            ) : (
                                <tr>
                                    <td className="text-center" colSpan="3">No Status Found</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                {this.addStatusModalJsx()}
            </Ax>
        )
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        permissions: state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps)(Workflow);